import React from "react";
import Select from "./Select";
import { graphql } from "react-apollo";
import { gql } from "apollo-boost";

const DraftsmanSelect = ({
  data: { loading, error, users },
  placeholder,
  ...otherProps
}) => {
  let status;

  if (loading) status = "Loading...";
  else if (error) status = "Could not load draftsmen.";
  else if (!users.length) status = "There are no draftsmen.";

  return (
    <Select
      {...otherProps}
      options={users}
      placeholder={status || placeholder}
      valueKey="id"
      labelKey="name"
    />
  );
};

export const DraftsmenQuery = gql`
  query DraftsmenQuery {
    users(type: "draftsman") {
      id
      name
      email
      phone
      role
    }
  }
`;

export default graphql(DraftsmenQuery, {
  options: {
    fetchPolicy: "network-only"
  }
})(DraftsmanSelect);



// WEBPACK FOOTER //
// ./src/components/forms/DraftsmanSelect.js